<template>
  <div>
    <andes-header></andes-header>
    <div class="container passengersPage">
      <div class="row">
        <div class="col-md-9">
          <h3>{{ $t('DATOS DE LOS PASAJEROS') }}</h3>
          <p>{{ $t('Por favor complete los datos de faltantes de todos los pasajeros.') }}</p>
          <hr/>

          <div v-for="(adult, index) in adults" :key="`adult-${index}`" class="mb-5">
            <h4><font-awesome-icon icon="user"/> PASAJERO {{index + 1}} - Adulto</h4>
            <passenger-form :passenger="adult" ref="adult" type="adult"></passenger-form>
          </div>
          <div v-for="(child, index) in childs" :key="`child-${index}`" class="mb-5">
            <h4><font-awesome-icon icon="user"/> PASAJERO {{index + adults.length + 1}} - Menor</h4>
            <passenger-form :passenger="child" ref="child" type="child"></passenger-form>
          </div>
          <div v-for="(inf, index) in infants" :key="`inf-${index}`" class="mb-5">
            <h4><font-awesome-icon icon="user"/> INFANTE {{index + 1}}</h4>
            <passenger-form :passenger="inf" ref="inf" type="infant"></passenger-form>
          </div>
          <!--hr class="mb-3"/>
          <h4><font-awesome-icon icon="envelope"/> {{ $t('INFORMACION DE CONTACTO') }}</h4>
          <contact-form :contact="contact" ref="contactView" class="mb-5" :onCopyFirstAdult="onCopyFirstAdult"></contact-form-->
        </div>
        <div class="col-md-3">
<!--          <summary-form :onContinue="onContinue"></summary-form>-->
          <div class="card-buttons text-center">
            <button type="button" class="btn" @click="onContinue">{{ $t('Continuar') }}</button>
          </div>
        </div>
      </div>
    </div>
    <loading-modal v-show="loading"></loading-modal>
    <andes-footer></andes-footer>
  </div>
</template>

<script>
  import { passengersInfo } from '@/api/api';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import PassengerForm from '../components/passengers/PassengerForm';
  import AndesHeader from "../components/AndesHeader";
  import AndesFooter from "../components/AndesFooter";
  import LoadingModal from "../components/LoadingModal";

  export default {
    name: 'passengers-uncompleted',
    components: {
      AndesHeader,
      AndesFooter,
      LoadingModal,
      PassengerForm},
    data: function () {
      return {
        adults: [],
        childs: [],
        infants: [],
        contact: {"EmailAddress":"", "FirstName":"", "LastName": "", "HomePhone":"", "OtherPhone":""}
      }
    },
    computed: {
      ...mapState(['booking', 'passengerID', 'loading']),
      childCountInt: function() {
        return parseInt(this.childCount);
      },
      adultCountInt: function() {
        return parseInt(this.adultCount)
      },
      infantCountInt: function() {
        return parseInt(this.infantCount)
      }
    },
    methods: {
      onContinue: function() {
        var isValid = true;
        for (var i=0; i < this.adults.length; i++) {
          isValid = this.$refs["adult"][i].validate() && isValid;
        }

        for (i=0; i < this.childs.length; i++) {
          isValid = this.$refs["child"][i].validate() && isValid;
        }

        for (i=0; i < this.infants.length; i++) {
          isValid = this.$refs["inf"][i].validate() && isValid;
        }

        //isValid = this.$refs.contactView.validate() && isValid;
        if (isValid) {
          this.postInformation();
        }
      },
      postInformation: function () {
        this.$store.commit('loading', true);
        let checkLength = true;
        if (this.passengerID) checkLength = false;
        passengersInfo(this.booking.BookingID, [...this.adults, ...this.childs, ...this.infants], this.contact, checkLength, (result) => {
          this.$store.dispatch('updateBooking', result);
          this.$router.replace('seatmap');
          this.$store.commit('loading', false);
        });
      },
      onCopyFirstAdult: function () {
        this.contact.FirstName = this.adults[0].FirstName;
        this.contact.LastName = this.adults[0].LastName;
      }
    },
    mounted() {
      if (_.isEmpty(this.booking)){
       this.$router.replace('/');
      }
      const nodeEnv = (process.env && process.env.NODE_ENV) ? process.env.NODE_ENV : '';
      const isDev = nodeEnv === 'development' || nodeEnv === '"development"';
      if (this.booking) {
        const departureDate = this.booking?.Passengers?.[0]?.Segments?.[0]?.DepartureDate;
        const baseDeparture = departureDate ? moment(departureDate, "YYYY-MM-DD") : moment();

        const dummyAdultDOB = baseDeparture.clone().subtract(30, 'years').format("YYYY-MM-DD");
        const dummyChildDOB = baseDeparture.clone().subtract(6, 'years').format("YYYY-MM-DD");
        const dummyInfantDOB = baseDeparture.clone().subtract(1, 'years').format("YYYY-MM-DD");
        const dummyGender = "MALE";
        const dummyNationality = "AR";
        const dummyDocType = "DNI";
        const dummyAdultDocNumber = "12345678";
        const dummyChildDocNumber = "87654321";
        const dummyInfantDocNumber = "11223344";
        const dummyLastName = "PEREZ";
        const dummyFirstName = "JUAN";
        const dummyMiddleName = "DEV";

        this.adults = []
        this.childs = []
        this.infants = []

        for (var passenger of this.booking.Passengers) {
          if (this.passengerID && passenger.PassengerID != this.passengerID) continue;
          const isAdultType = passenger.PaxType == 'ADT' || passenger.PaxType == 'NREV' || passenger.PaxType == 'CBUS';
          const paxDOB = isAdultType ? dummyAdultDOB : dummyChildDOB;
          const paxDocNumber = isAdultType ? dummyAdultDocNumber : dummyChildDocNumber;

          var p = {
            FirstName: isDev ? dummyFirstName : passenger.FirstName,
            MiddleName: isDev ? dummyMiddleName : passenger.MiddleName,
            LastName: isDev ? dummyLastName : passenger.LastName,
            DOB: isDev ? paxDOB : passenger.DOB,
            Gender: isDev ? dummyGender : passenger.Gender,
            PaxType: passenger.PaxType,
            DocTypeCode: isDev ? dummyDocType : passenger.DocTypeCode,
            DocNumber: isDev ? paxDocNumber : passenger.DocNumber,
            Nationality: isDev ? dummyNationality : passenger.Nationality,
            PassportDueDate:"",
            PassportCountry:"",
            PassengerID: passenger.PassengerID,
          }
          if (passenger.PaxType == 'ADT' || passenger.PaxType == 'NREV' || passenger.PaxType == 'CBUS') {
            this.adults.push(p);
          } else {
            this.childs.push(p);
          }

          for (var infant of passenger.Infants) {
            this.infants.push({
              FirstName: isDev ? dummyFirstName : infant.FirstName,
              MiddleName: isDev ? dummyMiddleName : infant.MiddleName,
              LastName: isDev ? dummyLastName : infant.LastName,
              DOB: isDev ? dummyInfantDOB : infant.DOB,
              Gender: isDev ? dummyGender : infant.Gender,
              PaxType: "INF",
              DocTypeCode: isDev ? dummyDocType : infant.DocTypeCode,
              DocNumber: isDev ? dummyInfantDocNumber : infant.DocNumber,
              Nationality: isDev ? dummyNationality : infant.Nationality,
            })
          }
        }

        if (this.booking.ContactInformation && this.booking.ContactInformation.length > 0) {
          this.contact = {
            "EmailAddress": this.booking.ContactInformation[0].EmailAddress,
            "FirstName":this.booking.ContactInformation[0].FirstName,
            "LastName": this.booking.ContactInformation[0].LastName,
            "HomePhone": this.booking.ContactInformation[0].HomePhone,
            "OtherPhone":""
          }
        }
      }
    }

  }
</script>

